import Vue from 'vue'
import VueRouter from 'vue-router'
import layouts from '@/layouts/mainIndex.vue'

Vue.use(VueRouter)

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}
// 角色权限
// 2：管理员；3：教务员；4：学院管理员；5：教师；6：学生；7：游客
export const routes = [
  {
    path: '/',
    component: layouts,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'PlatformIndex',
        component: () => import('@/views/platform/index.vue'),
        meta: {
          title: '平台',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/courseOnline',
        name: 'CourseOnline',
        component: () => import('@/views/platform/courseOnline.vue'),
        meta: {
          title: '实时在线课程',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/courseList',
        name: 'CourseList',
        component: () => import('@/views/platform/courseList.vue'),
        meta: {
          title: '实时在线课程-课程列表',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/userOnline',
        name: 'UserOnline',
        component: () => import('@/views/platform/userOnline.vue'),
        meta: {
          title: '实时学习人数',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/userList',
        name: 'UserList',
        component: () => import('@/views/platform/userList.vue'),
        meta: {
          title: '实时学习人数-用户列表',
          activeTop: 'nav-platform',
          activeSub: 'nav-platform-index',
        },
      },
      {
        path: '/platform/attributeCourse',
        name: 'AttributeCourse',
        component: () => import('@/views/platform/attributeCourse.vue'),
        meta: {
          title: '属性课程',
          activeTop: 'nav-platform',
          activeSub: 'sub-platform',
        },
      },
      {
        path: '/platform/invalidCourse',
        name: 'InvalidCourse',
        component: () => import('@/views/platform/invalidCourse.vue'),
        meta: {
          title: '无效课程',
          activeTop: 'nav-platform',
          activeSub: 'nav-invalid-course',
        },
      },
      {
        path: '/platform/accessAnalyse',
        name: 'AccessAnalyse',
        component: () => import('@/views/platform/accessAnalyse.vue'),
        meta: {
          title: '访问分析',
          activeTop: 'nav-platform',
          activeSub: 'nav-access-analyse',
        },
      },
    ],
  },
  {
    path: '/course',
    component: layouts,
    children: [
      {
        path: '/course',
        name: 'course',
        component: () => import('@/views/course/index.vue'),
        meta: {
          title: '所有课程',
          activeTop: 'nav-course',
          activeSub: 'nav-course-index',
        },
      },
      {
        path: '/course/courseRank',
        name: 'courseRank',
        component: () => import('@/views/course/courseRank/index.vue'),
        meta: {
          title: '课程排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/activeRank',
        name: 'activeRank',
        component: () => import('@/views/course/courseRank/activeRank.vue'),
        meta: {
          title: '活跃度排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/publishRank',
        name: 'publishRank',
        component: () => import('@/views/course/courseRank/publishRank.vue'),
        meta: {
          title: '课程发布排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/resourceRank',
        name: 'resourceRank',
        component: () => import('@/views/course/courseRank/resourceRank.vue'),
        meta: {
          title: '课程资源排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
      {
        path: '/course/courseRank/discussRank',
        name: 'discussRank',
        component: () => import('@/views/course/courseRank/discussRank.vue'),
        meta: {
          title: '课程讨论排行',
          activeTop: 'nav-course',
          activeSub: 'nav-course-rank',
        },
      },
    ],
  },

  {
    path: '/courseDetail',
    component: layouts,
    children: [
      {
        path: '/courseDetail',
        name: 'courseDetail',
        component: () => import('@/views/course/courseDetail.vue'),
        redirect: '/courseDetail/baseInfo',
        meta: {
          title: '课程详情',
          activeTop: 'nav-course',
          activeSub: 'nav-course-index',
        },
        children: [
          {
            path: '/courseDetail/baseInfo',
            name: 'baseInfo',
            component: () => import('@/views/course/baseInfo/index.vue'),
            meta: {
              title: '基本情况',
              activeMenu: '/courseDetail/baseInfo',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/teachCount',
            name: 'teachCount',
            component: () => import('@/views/course/teachCount/index.vue'),
            meta: {
              title: '教学统计',
              activeMenu: '/courseDetail/teachCount',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/teachCount/courseActivity',
            name: 'teachActivity',
            component: () => import('@/views/course/teachCount/courseActivity.vue'),
            meta: {
              title: '教学活动详情',
              activeMenu: '/courseDetail/teachCount',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studyAnalyse',
            name: 'studyAnalyse',
            component: () => import('@/views/course/studyAnalyse/index.vue'),
            meta: {
              title: '学情分析',
              activeMenu: '/courseDetail/studyAnalyse',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studentDoc',
            name: 'studentDoc',
            component: () => import('@/views/course/studentDoc/index.vue'),
            meta: {
              title: '学员档案',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/myDoc',
            name: 'myDoc',
            component: () => import('@/views/course/studentDoc/studentDetail.vue'),
            meta: {
              title: '我的档案',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/studentDoc/studentDetail',
            name: 'studentDetail',
            component: () => import('@/views/course/studentDoc/studentDetail.vue'),
            meta: {
              title: '学员档案详情',
              activeMenu: '/courseDetail/studentDoc',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
          {
            path: '/courseDetail/abnormalWarn',
            name: 'abnormalWarn',
            component: () => import('@/views/course/abnormalWarn/index.vue'),
            meta: {
              title: '异常预警',
              activeMenu: '/courseDetail/abnormalWarn',
              activeTop: 'nav-course',
              activeSub: 'nav-course-index',
            },
          },
        ],
      },
    ],
  },

  {
    path: '/ability-framework',
    component: layouts,
    redirect: '/ability-framework/index',
    children: [
      {
        path: '/ability-framework/index',
        name: 'abilityFramework',
        component: () => import('@/views/ability-framework/index.vue'),
        meta: {
          title: '能力框架',
          activeTop: 'nav-ability-framework',
          activeSub: 'nav-ability-framework-index',
        },
      },
      {
        path: '/ability-framework/course',
        name: 'abilityCourse',
        component: () => import('@/views/ability-framework/course.vue'),
        meta: {
          title: '课程能力图谱',
          activeTop: 'nav-ability-framework',
          activeSub: 'nav-ability-framework-index',
        },
      },
      {
        path: '/ability-framework/detail/:id',
        name: 'abilityDetail',
        component: () => import('@/views/ability-framework/detail.vue'),
        meta: {
          title: '能力图谱详情',
          activeTop: 'nav-ability-framework',
          activeSub: 'nav-ability-framework-index',
        },
      },
      {
        path: '/ability-framework/edit/:id',
        name: 'abilityEdit',
        component: () => import('@/views/ability-framework/edit.vue'),
        meta: {
          title: '能力图谱详情',
          activeTop: 'nav-ability-framework',
          activeSub: 'nav-ability-framework-list',
        },
      },
    ],
  },
  {
    path: '/ability-graph',
    component: layouts,
    redirect: '/ability-graph/index',
    children: [
      {
        path: '/ability-graph/index',
        name: 'AbilityGraphList',
        component: () => import('@/views/ability-graph/index.vue'),
        meta: {
          title: '图谱列表',
          activeTop: 'nav-ability-graph',
          activeSub: 'nav-ability-graph-index',
        },
      },
      {
        path: '/ability-graph/detail',
        name: 'abilityChart',
        component: () => import('@/views/ability-graph/abilityChart/index.vue'),
        redirect: '/ability-graph/detail/baseInfo',
        meta: {
          title: '能力图谱',
          activeTop: 'nav-ability-graph',
          activeSub: 'nav-ability-graph-index',
        },
        children: [
          {
            path: '/ability-graph/detail/baseInfo',
            name: 'abilityBaseInfo',
            component: () => import('@/views/ability-graph/abilityChart/baseInfo.vue'),
            meta: {
              title: '图谱概况',
              activeTop: 'nav-ability-graph',
              activeSub: 'nav-ability-graph-index',
            },
          },
          {
            path: '/ability-graph/detail/configure',
            name: 'abilityConfigure',
            component: () => import('@/views/ability-graph/abilityChart/configure.vue'),
            meta: {
              title: '配置图谱',
              activeTop: 'nav-ability-graph',
              activeSub: 'nav-ability-graph-index',
            },
          },
          {
            path: '/ability-graph/detail/achieve',
            name: 'abilityAchieve',
            component: () => import('@/views/ability-graph/abilityChart/achieve.vue'),
            meta: {
              title: '能力达成',
              activeTop: 'nav-ability-graph',
              activeSub: 'nav-ability-graph-index',
            },
          },
          {
            path: '/ability-graph/detail/my-achieve',
            name: 'myAchieve',
            component: () => import('@/views/ability-graph/abilityChart/my-achieve.vue'),
            meta: {
              title: '我的能力达成',
              activeTop: 'nav-ability-graph',
              activeSub: 'nav-ability-graph-index',
            },
          },
        ]
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash',
})

export default router
